export const CONFIG = {
  API_URL: 'https://api.japedido.com.br/api',
  IMAGE_URL: 'https://api.japedido.com.br'
};
